import { createContext, useContext, useEffect } from 'react';
import type { BreadcrumbEntry } from './navUtils';

/** Set by the shell; a page that sits below a list (a record opened from it) replaces the menu-derived trail. */
export const PageBreadcrumbsContext = createContext<(crumbs: BreadcrumbEntry[] | null) => void>(
  () => {},
);

/**
 * Replaces the AppBar breadcrumb while the page is shown — e.g. Admission › Applicants › APP-2026-0013 for an
 * application opened from the Applicants list. The last entry is the page title. `null` keeps the menu trail.
 */
export function usePageBreadcrumbs(crumbs: BreadcrumbEntry[] | null) {
  const setCrumbs = useContext(PageBreadcrumbsContext);
  const key = crumbs ? JSON.stringify(crumbs) : null;
  useEffect(() => {
    if (!key) return;
    setCrumbs(JSON.parse(key) as BreadcrumbEntry[]);
    return () => setCrumbs(null);
  }, [key, setCrumbs]);
}
